/**
 * 手机交互
 * */

export default {
    interactiveRet : -1,//返回上一级
    // interactiveAddressRet : -2,//地址返回上一级
    interactiveRetGoodsOrder: -3,
    interactiveRetGoodsInfo: -4,
    // // interactiveLogin:10,//返回登录页
    interactivePay:9,//支付
    interactiveShare:8,//分享



    interactiveTitle:0,//标题
    interactiveLogin:10,//返回登录页
    interactiveCart:11,//返回购物车
    interactiveChangeAddress:12,//切换收货地址

};
